import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapState } from 'vuex';
import Nick from '@/components/UI/Nick';
export default {
  components: {
    Nick: Nick
  },
  data: function data() {
    return {
      current: 'bump'
    };
  },
  filters: {
    dateFormat: function dateFormat(date) {
      date = new Date(date * 1000);
      return ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日  ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
    }
  },
  methods: {
    goToMyPrize: function goToMyPrize() {
      if (this.isLogin) {
        if (!this.noBumpRecord) {
          this.openUrl(window.setting.我的礼包);
        }
      } else {
        this._openLogin();
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('bump', ['bumpEggRecord', 'fetchEggRecord'])), {}, {
    empty: function empty() {
      return this.current === 'bump' ? this.bumpEggRecord.length === 0 : this.fetchEggRecord.length === 0;
    },
    noBumpRecord: function noBumpRecord() {
      return this.bumpEggRecord.length === 0;
    },
    emptyEgg: function emptyEgg() {
      return this.setting.流水兜底图;
    },
    未中奖奖品: function 未中奖奖品() {
      return window.setting.未中奖奖品;
    },
    tabImg: function tabImg() {
      var setting = this.setting;

      if (this.current === 'bump') {
        return setting.碰蛋战绩态;
      }

      return setting.获蛋记录态;
    }
  }),
  settingKey: '记录模块',
  setting: {
    碰蛋战绩态: 'https://puui.qpic.cn/vupload/0/20190724_1563939170216_uqwvysegtj.png/0',
    获蛋记录态: 'https://puui.qpic.cn/vupload/0/20190724_1563939154153_9n1z2a0oq0u.png/0',
    查看奖品按钮: 'https://puui.qpic.cn/vupload/0/20190627_1561636375004_6wgth7oa9c9.png/0',
    查看奖品按钮灰: 'https://puui.qpic.cn/vupload/0/1562934604884_27zt1mdg8wz/0',
    流水兜底图: 'https://puui.qpic.cn/vupload/0/20190619_1560911588818_q1am3aeys8d.png/0'
  }
};